import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { generatePath } from 'react-router-dom';
import { Pagination, Response } from '@ui/src';
import { LockAuditLog } from '../../types';
import { securityApi } from '../services';

import ROUTES from '../../../../routes';

export interface SecurityLogsState {
  logs?: LockAuditLog[];
  pagination?: Pagination;
  logItem?: LockAuditLog;
  takeCount?: number;
  logItemUser?: {
    serviceRole?: string[];
    id: string;
    profile: {
      firstName: string;
      lastName: string;
    };
  };
}

const initialState: SecurityLogsState = {};

export const securityLogsSlice = createSlice({
  name: 'securityLogs',
  initialState,
  reducers: {
    setTakeCount: (state, action: PayloadAction<number>) => {
      state.takeCount = action.payload;
    },
    clearLogsState: (state) => {
      state.logs = undefined;
      state.pagination = undefined;
      state.takeCount = undefined;
    },
    clearLogPanelState: (state) => {
      state.logItem = undefined;
      state.logItemUser = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      securityApi.endpoints.getLocksAuditLogs.matchFulfilled,
      (state, action: PayloadAction<Response<LockAuditLog>>) => {
        state.logs = action.payload.data.edges.map((item) => ({
          ...item.node,
          url: generatePath(ROUTES.SECURITY_LOGS_ITEM, {
            logId: item.node.id,
          }),
        }));

        state.pagination = action.payload.data.pageInfo;
      },
    );
    builder.addMatcher(
      securityApi.endpoints.getLocksAuditLogItem.matchFulfilled,
      (state, action: PayloadAction<{ data: LockAuditLog }>) => {
        state.logItem = action.payload.data;
      },
    );
    builder.addMatcher(
      securityApi.endpoints.getLockItemUser.matchFulfilled,
      (
        state,
        action: PayloadAction<{
          data: {
            id: string;
            profile: {
              firstName: string;
              lastName: string;
            };
          };
        }>,
      ) => {
        state.logItemUser = action.payload.data;
      },
    );
  },
});

export const { clearLogsState, clearLogPanelState, setTakeCount } =
  securityLogsSlice.actions;

export default securityLogsSlice.reducer;
